import { REQUIREMENT_FIELD_MAP, REQUIREMENT_STEP_MAP } from "./constants";

export function getRequirementSentence(requirements) {
	if (!requirements || !requirements.length) {
		return null;
	}

	let sentence;
	const requirementList = [];

	requirements.forEach((requirement) => {
		if (REQUIREMENT_FIELD_MAP[requirement]) {
			requirementList.push(REQUIREMENT_FIELD_MAP[requirement]);
		}
	});

	const requirementLength = requirementList.length;

	if (!requirementList.length) {
		return "";
	}

	if (requirementLength === 2) {
		sentence = `${requirementList[0]} and ${requirementList[1]}`;
	} else if (requirementLength > 2) {
		const subArray = requirementList.slice(0, requirementLength - 1);
		const lastItem = requirementList[requirementLength - 1];

		sentence = `${subArray.join(", ")}, and ${lastItem}`;
	} else {
		sentence = requirementList[0];
	}

	sentence = `Please fill out your ${sentence}`;

	return sentence;
}

export function getFirstIncompletedStep(incompletedFields, fieldOrder) {
	// gets a list of incompleted steps from signup/completion
	// loop through and compare it against the field order

	let incompletedSteps = {};

	incompletedSteps = incompletedFields.reduce((prev, field) => {
		let newPrev = prev;

		if (REQUIREMENT_STEP_MAP[field] && !newPrev[REQUIREMENT_STEP_MAP[field]]) {
			newPrev = {
				...newPrev,
				[REQUIREMENT_STEP_MAP[field]]: true,
			};
		}

		return newPrev;
	}, incompletedSteps);

	const firstIncompletedStep = fieldOrder.find((field) => { return incompletedSteps[field.name]; });

	return firstIncompletedStep || fieldOrder[0];
}

// Check if user is reboarding (rather than onboarding).
export const isReboarding = () => {
	const { search: queryParams = "" } = window.location || {};

	return queryParams.includes("needs_reboarding=1");
};

export const isDetailsReboarding = () => {
	const { search: queryParams = "" } = window.location || {};

	return isReboarding() && queryParams.includes("details_reboarding=1");
};



// WEBPACK FOOTER //
// ./src/apps/onboarding/util/helper.js